/**
 *@des Application page routing details
 *@author Eshan
 */
const PageRoutes = {
  WELCOME: "welcome",
  PRODUCT_SELECTION: "product-selection",
  LOGIN: "login",
  EXISTING_USER: "existing-user",
  EDIT_APPLICATION: "edit-application",
  CONSOLE: "console",
  PORTAL: "portal",
  CONSENT: "consent",
  OTP: "otp",
  DYNAMIC_FORM: "dynamic-form",
};

export default PageRoutes;
